export default __webpack_public_path__ + "static/media/bg-icons.840739a7.svg";